import { useEffect, useState } from "react";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { FUNDER_NAV } from "./FunderTerminal";

export default function FunderAuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async()=>{ const r = await api.get("/funder/audit"); setRows(r.data); })(); }, []);
  return (
    <AppShell nav={FUNDER_NAV}>
      <h1 className="text-3xl font-bold text-neutral-900">Audit trail</h1>
      <p className="mt-1 text-sm text-neutral-600">Every VDR access, document download, and mandate change — fully tracked.</p>
      <div className="mt-6 overflow-hidden rounded-2xl border border-neutral-200 bg-white">
        <div className="grid grid-cols-12 bg-neutral-50 px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-neutral-500">
          <div className="col-span-3">Time</div><div className="col-span-3">Action</div><div className="col-span-6">Detail</div>
        </div>
        {rows.length === 0 ? <p className="p-8 text-center text-sm text-neutral-500">No activity yet.</p> :
          rows.map(r => (
            <div key={r.audit_id} className="grid grid-cols-12 items-center gap-2 border-t border-neutral-100 px-5 py-3 text-sm" data-testid={`audit-${r.audit_id}`}>
              <div className="col-span-3 text-xs text-neutral-500">{new Date(r.created_at).toLocaleString()}</div>
              <div className="col-span-3"><span className="rounded bg-[#0A8B85]/10 px-2 py-0.5 text-xs font-mono font-semibold text-[#0A8B85]">{r.action}</span></div>
              <div className="col-span-6 text-neutral-700">{r.meta?.company_name || r.meta?.filename || r.target_id || "—"}</div>
            </div>
          ))}
      </div>
    </AppShell>
  );
}
